import React from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";
import {INavLink} from "modules/types/routing";

const Wrapper = styled.div`
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	display: flex;
	justify-content: center;
	text-align: center;

	a {
		display: block;
		height: 48px;
		width: 100%;
		line-height: 48px;
		padding: 0 2px;
		font-size: 16px;
		font-weight: 500;
		font-family: "Hind", sans-serif;
		color: ${({theme}) => theme.color.linkColor};
		border-bottom: 2px solid ${({theme}) => theme.color.linkBorderColor};
		white-space: nowrap;
	}

	a.active,
	a:hover {
		color: ${({theme}) => theme.color.secondary};
		border-bottom: 2px solid ${({theme}) => theme.color.secondary};
	}

	@media (min-width: 769px) {
		a {
			padding: 0 16px;
		}
	}
`;

interface INavigation {
	links: INavLink[];
}

export const Navigation: React.FC<INavigation> = ({links}) => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			{links.map(({title, href}) => (
				<NavLink key={title} to={href}>
					{t(title)}
				</NavLink>
			))}
		</Wrapper>
	);
};
